import PageHeader from "../components/PageHeader";
import HireMobileDeveloperContent from "../components/HireMobileAppDevelopers-Content";

const HireMobileAppDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Mobile App Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Mobile App Developer" image="/images/mobile-app-development.jpg" />
            <HireMobileDeveloperContent />
        </>
    )
}

export default HireMobileAppDevelopers;